import { otmsHttp, wmsPlusHttp, bfsUserWebHttp } from '@/utils/http/index';
import { USER } from '@/constant/storage';
import { localStorageGet } from '@/utils/localStorage';

// 新增/修改货主
// https://yapi.ops.yunlizhi.cn/project/295/interface/api/8490
export function editCustomer(data) {
  return otmsHttp.post('/customer/upsert_by_platform', data);
}

// 修改货主
// https://yapi.ops.yunlizhi.cn/project/295/interface/api/8492
// export function updateCustomer(data) {
//   return otmsHttp.post('/customer/update', data);
// }

/**
 * 修改服务设置
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/11938
 */
export function updateSetting(data) {
  return otmsHttp.post('/order/config/upsert', data);
}

// 查询下级列表
export function getChildrenPage(data, query) {
  return otmsHttp.post('/customer/bind_children_page', {
    ...data,
    carrierTenantId: localStorageGet(USER)?.ext?.tenantId,
  }, {
    params: query,
  });
}

// 货主列表
// https://yapi.ops.yunlizhi.cn/project/295/interface/api/8484
export function getCustomerList(data, query) {
  return otmsHttp.post('/customer/page_by_platform', data, {
    params: {
      ...query,
      sort: 'create_time__DESC',
    },
  });
}

// 货主详情
// https://yapi.ops.yunlizhi.cn/project/295/interface/api/8488
export function getCustomerDetail(data) {
  return otmsHttp.post('/customer/detail/list', data);
}

// 运力承运商列表
// https://yapi.ops.yunlizhi.cn/project/138/interface/api/6050
export function getTransportList(data) {
  return otmsHttp.post('/tcs_plus/transport_supplier/list', data);
}

// 货主启用
export function shipperEnable(data) {
  return otmsHttp.post('/crm_plus/customer/enable', data);
}

// 货主禁用
export function shipperDisable(data) {
  return otmsHttp.post('/crm_plus/customer/disable', data);
}
/**
 * 解绑和绑定
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/16783
 */
export function upsert(data) {
  return wmsPlusHttp.post('/warehouse_foundation/shipper/change/bind', data);
}

// 查看绑定的仓库列表
export function boundList(data) {
  return wmsPlusHttp.post('/warehouse_foundation/shipper/bound_list', data);
}

// 仓库查询接口
export function getList(data, params) {
  return wmsPlusHttp.post('/warehouse_foundation/warehouse/page', data, {
    params,
  });
}
/**
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9210
 * 组织分页
 */
export function getOrganizationList(data) {
  return bfsUserWebHttp.post('/bfs-user/organization/page', data,
    {
      params: {
        page: 1,
        size: 1000,
      },
    });
}

export function getNewOrganizationList(data, page, size) {
  return bfsUserWebHttp.post(`/bfs-user/organization/page?page=${page}&size=${size}`, data);
}

/**
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/25310
 * @param data
 * @param page
 * @param size
 * @returns {*}
 */
export function getProjectList(data, page, size) {
  return otmsHttp.post(`/crm-plus/project/page?page=${page}&size=${size}`, data);
}
/**
 * 查询项目
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9210
 */
export function fetchProject(data) {
  return otmsHttp.post('/customer/organization/project/page', data, {
    params: {
      page: 1,
      size: 1000,
      sort: 'createTime__DESC',
    },
  });
}

/**
 * 获取客户合同条款
 * https://yapi.ops.yunlizhi.cn/project/202/interface/api/9294
 */
export function getContractList(data) {
  return otmsHttp.post('/bfs_pricing_rule/contract/cargo_owner/list', data);
}

/**
 *
 * 当前货主作为租户（承运商）对应的所有启用货主
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/8484
 */
export function getCustomer(data) {
  return otmsHttp.post('/platform/customer/page', data, {
    params: {
      page: 1,
      size: 1000,
    },
  });
}

/**
 * 获取货主规则
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/11946
 */
export function getRule(params) {
  return otmsHttp.get('/order/config/query', {}, {
    params,
  });
}

/**
 * 获取用户合同列表
 * https://yapi.ops.yunlizhi.cn/project/210/interface/api/2181
 */
export function getUserContractList(params) {
  return bfsUserWebHttp.post('/bfs_econtract/user/contract/list', params);
}

/**
 * 获取预览用户合同地址
 * https://yapi.ops.yunlizhi.cn/project/210/interface/api/2185
 */
export function getContractPreview(data) {
  return bfsUserWebHttp.post('/bfs_econtract/user/contract/preview', data);
}

/**
 * 查询货主列表
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/12400
 */
export function shipperList(data, params) {
  return wmsPlusHttp.post('/warehouse_foundation/shipper/v2/page', data, { params });
}

/**
 * 社会信用代码 模糊搜索
 * https://yapi.ops.yunlizhi.cn/project/442/interface/api/15677
 */
export function creditCode(data, params) {
  return otmsHttp.post('bfs_merchant/open/merchant/corp/list', data, { params });
}
/**
 * 企业二要素认证
 * https://yapi.ops.yunlizhi.cn/project/274/interface/api/10598
 */
export function enterprisetTwoElements(data) {
  return otmsHttp.post('bfs_identity/enterprise/identity/two_elements', data);
}
/**
 * 货主服务设置流程创建
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/23623
 */
export function processRuleCustomerCreate(data) {
  return otmsHttp.post('/cms_plus/process_rule/customer/create', data);
}

/**
 * 货主服务设置流程更新
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/23625
 */
export function processRuleCustomerUpdate(data) {
  return otmsHttp.post('/cms_plus/process_rule/customer/update', data);
}

/**
 * 根据货主查询(货主配置)
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/cat_12560
 */
export function customerProcessRule(data) {
  return otmsHttp.post('/cms_plus/process_rule/customer/detail/list', data);
}

/**
 * 获取配置
 */
export function getConfigList(data) {
  return otmsHttp.post('/config/query', data);
}

/**
 * 转派模拟
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/42839
 */

export function ruleResolveAssignSimulate(data) {
  return otmsHttp.post('/cms_plus/rule_resolve/assign/simulate', data);
}

/**
 * 转派日志
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/42711
 */

export function assignLogPage(data, params) {
  return otmsHttp.post('/cms_plus/assign/log/page', data, { params });
}
